// Tarjeta de sección de la ficha (`.fcard` del mock): encabezado en mayúsculas y cuerpo.
import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

export function DetailCard({
    title,
    aside,
    flush = false,
    tone = 'default',
    children,
}: {
    title: ReactNode;
    /** Lo que va a la derecha del encabezado. */
    aside?: ReactNode;
    /** Sin relleno: para una tabla que va de borde a borde. */
    flush?: boolean;
    /** `warning` e `info` llevan la franja izquierda de aviso del mock. */
    tone?: 'default' | 'warning' | 'info';
    children: ReactNode;
}) {
    return (
        <section
            className={cn(
                'mb-3 overflow-hidden rounded-md border border-border bg-card',
                tone === 'warning' && 'border-l-[3px] border-l-warning bg-warning-soft/40',
                tone === 'info' && 'border-l-[3px] border-l-info bg-info-soft/40',
            )}
        >
            <header className="flex items-center justify-between gap-2 border-b border-border bg-muted/30 px-3 py-[7px]">
                <h3
                    className={cn(
                        'text-[10.5px] font-bold uppercase tracking-[0.04em]',
                        tone === 'warning'
                            ? 'text-warning'
                            : tone === 'info'
                              ? 'text-info'
                              : 'text-muted-foreground',
                    )}
                >
                    {title}
                </h3>
                {aside === undefined ? null : (
                    <span className="text-[10px] text-muted-foreground">{aside}</span>
                )}
            </header>
            <div className={cn('flex flex-col', !flush && 'px-3 py-2')}>{children}</div>
        </section>
    );
}
